/**
 * Skip Link Component
 * 
 * Provides skip navigation links for accessibility.
 */

import React from 'react'
import { useSkipLink } from '../../hooks/useFocusManagement'

interface SkipLinkProps {
  /**
   * ID of the element to skip to
   */
  targetId: string
  
  /**
   * Text to display
   */
  text?: string
}

/**
 * SkipLink - Skip navigation link for accessibility
 * 
 * @example
 * ```tsx
 * <SkipLink targetId="main-content" />
 * ```
 */
export default function SkipLink({ targetId, text = 'Skip to main content' }: SkipLinkProps) {
  const { handleSkip } = useSkipLink(targetId)

  return (
    <a
      href={`#${targetId}`}
      onClick={handleSkip}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[999999] focus:px-4 focus:py-2 focus:bg-salt-navy focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-salt-gold"
    >
      {text}
    </a>
  )
}

